import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { meetBackgroundReducer } from "./meet-background.reducer";
import { MeetBackgroundEffects } from "./meet-background.effects";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature("meetBackground", meetBackgroundReducer),
    EffectsModule.forFeature([MeetBackgroundEffects]),
  ],
})
export class MeetBackgroundModule {}
